'use client'

// Narrow, per-concern selector hook for the header cart badge (#118 server-chrome,
// Step 3). Mirrors the Step-1 read-seam discipline: exposes ONLY the derived cart
// item count from state.shoppingCart. Nothing else from the store leaks through.
//
// The #418 MOUNTED-GATE that hides the badge until after hydration lives in the
// CartNavCategoryIsland (verbatim from the old NavCategory), NOT here — this hook
// only reads the count; the island decides when to reveal it. Keeping the gate in
// the component preserves byte-identical SSR-vs-first-render for the badge.

import { useCartStore, selectCartCount } from '../../store/cartStore'

export function useCartCount() {
  // Cart now lives in the Zustand cart store (Bucket C). skipHydration keeps the
  // count 0 during SSR + the first client render (the CartNavCategoryIsland
  // mounted-gate still hides the badge until then), then it reflects the real
  // count once <CartStoreHydrator/> rehydrates from localStorage post-mount.
  const count = useCartStore(selectCartCount)
  return { count }
}
